module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/hairstyle_03-96bbd2c37f595a0cf4e0f851db35c007.webp";